export const isReactWeb = (): boolean => true;
export const isReactNative = (): boolean => false;
export const isAndroid = (): boolean => false;
export const isIOS = (): boolean => false;
